/**
 * Badge Component - UI Layer
 * Badge with color variants for status indicators
 */

import type { ReactNode } from 'react';
import styles from './Badge.module.css';

type BadgeVariant = 'default' | 'success' | 'warning' | 'danger' | 'info';

interface BadgeProps {
  variant?: BadgeVariant;
  children: ReactNode;
  className?: string;
}

export function Badge({ variant = 'default', children, className = '' }: BadgeProps) {
  const classNames = [styles.badge, styles[variant], className].filter(Boolean).join(' ');

  return <span className={classNames}>{children}</span>;
}
